import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { Terminal } from "@phosphor-icons/react";

export default function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success("Account created");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] p-6 grid-bg">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6 bg-[#0A0A0A] border border-[#262626] p-8" data-testid="register-form">
        <div className="flex items-center gap-2 mb-2">
          <Terminal size={20} weight="bold" className="text-[#0055FF]" />
          <span className="font-display font-black tracking-tight">DASHBOARD</span>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-widest text-[#71717A] mb-2">Create account</div>
          <h2 className="font-display text-3xl font-bold tracking-tight">Get started</h2>
        </div>
        <div className="space-y-3">
          <div>
            <Label className="text-xs uppercase tracking-wider">Name</Label>
            <Input
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="mt-1 rounded-sm bg-[#141414] border-[#262626]"
              data-testid="register-name-input"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider">Email</Label>
            <Input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="mt-1 rounded-sm bg-[#141414] border-[#262626]"
              required
              data-testid="register-email-input"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider">Password</Label>
            <Input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="mt-1 rounded-sm bg-[#141414] border-[#262626]"
              required
              minLength={6}
              data-testid="register-password-input"
            />
          </div>
        </div>
        <Button
          type="submit"
          disabled={loading}
          className="w-full rounded-sm bg-[#0055FF] hover:bg-[#0044CC] text-white h-10"
          data-testid="register-submit-btn"
        >
          {loading ? "Creating..." : "Create account"}
        </Button>
        <div className="text-sm text-[#A1A1AA] text-center">
          Have an account?{" "}
          <Link to="/login" className="text-white hover:underline">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
